"use client";

import Image from "next/image";
import { ShoppingBag, Star, Search, Tag } from "lucide-react";

const SUGGESTIONS = [
  { icon: ShoppingBag, text: "Parti için elbise öner" },
  { icon: Star, text: "En çok satan ürünler neler?" },
  { icon: Search, text: "Yazlık ayakkabı önerir misin?" },
  { icon: Tag, text: "Bütçeme uygun çanta var mı?" },
];

interface TozyEmptyStateProps {
  icon: string;
  onSuggestionClick: (text: string) => void;
}

const TozyEmptyState = ({ icon, onSuggestionClick }: TozyEmptyStateProps) => (
  <div className="flex flex-col items-center justify-center h-full px-4 py-8 gap-6">
    <div className="flex flex-col items-center gap-3 text-center">
      <div className="w-16 h-16 rounded-2xl bg-brand flex items-center justify-center shadow-lg overflow-hidden">
        <Image src={icon} alt="Tozzy" width={44} height={44} className="object-contain" />
      </div>
      <div>
        <h2 className="text-lg font-bold text-gray-900 tracking-tight">Merhaba! Ben Tozzy</h2>
        <p className="text-sm text-gray-500 mt-1 max-w-xs leading-relaxed">
          Tozlu&apos;nun AI alışveriş asistanıyım. Size uygun ürünleri bulmana yardımcı olurum.
        </p>
      </div>
    </div>

    <div className="w-full max-w-sm grid grid-cols-2 gap-2">
      {SUGGESTIONS.map(({ icon: Icon, text }) => (
        <button
          key={text}
          onClick={() => onSuggestionClick(text)}
          className="flex items-center gap-1.5 text-left bg-white hover:bg-gray-50 border border-gray-200 hover:border-brand text-gray-700 rounded-xl px-3.5 py-3 transition-all duration-150 group"
        >
          <Icon className="w-4 h-4 text-gray-400 group-hover:text-brand shrink-0 transition-colors duration-150" />
          <span className="text-xs leading-snug">{text}</span>
        </button>
      ))}
    </div>
  </div>
);

export default TozyEmptyState;